import { render, staticRenderFns } from "./StatsDetail.vue?vue&type=template&id=1cb34a46&scoped=true"
import script from "./StatsDetail.vue?vue&type=script&lang=js"
export * from "./StatsDetail.vue?vue&type=script&lang=js"
import style0 from "./StatsDetail.vue?vue&type=style&index=0&id=1cb34a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb34a46",
  null
  
)

export default component.exports